// extracted by mini-css-extract-plugin
export default {"main":"styles_main__7KF6j","header":"styles_header__+Wt4y","form":"styles_form__cxIjQ","actions":"styles_actions__79IZF"};